<template>
    <div class="container">

        <div class="header f-c">
            <i class="iconhebei iconshijian theme-color-font"></i>
            <span class="txt g-b-500">我的预约</span>
        </div>        

        <ul class="render-box">

            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >

                <li 
                    v-for="(item, index) in list" :key="index"
                    class="_item g-b-500"
                >
                    <div class="item-header">
                        预约时间: {{item.time}}
                    </div>
                    <ul class="item-body">
                        <li class="_info-row f-s-b">
                            <span class="language">{{item.language}} x {{item.languageNumber}}</span>
                            <span class="size">团人数: {{item.number}}</span>
                        </li>
                        <li class="_info-row f-s-b">
                            <span>预约人: {{item.name}}</span>
                            <span>手机号: {{item.phone}}</span>
                        </li>
                        <li class="_info-row">
                            <span>证件号: {{item.id}}</span>
                        </li>
                    </ul>
                    <div class="item-header item-foot f-s-b" v-if="item.type === 1">
                        <span class="suc-btn">预约成功</span>
                        <span class="cancel-btn f-c" v-touch:tap="cancelOrder(item)" v-if="item.isCan">取消预约</span>
                        <span class="cancel-btn f-c" v-else>不可取消</span>
                    </div>
                    <div class="item-header item-foot f-s-b" v-else>
                        <span class="suc-btn"></span>
                        <span class="cancel-btn txt f-c">已取消</span>
                    </div>
                </li>

            </van-list>

        </ul>

    </div>  
</template>

<script>
    import http from '@js/http-zyz.js';
    import {
        myVolunteerActivityListUrl,
        cancelVolunteerActivityUrl,
    } from '@js/volunteerUrl.js';
    import { 
        List,
    } from 'vant';
    export default {
        data() {
            return {
                loading: false,
                finished: false,
                list: [
                    // {
                    //     time: '2019-11-20  09:00',
                    //     language: 1,
                    //     languageNumber:1,
                    //     name: '王某',
                    //     phone: '139090909099',
                    //     number: 5,
                    //     id: '510101********9106',
                    //     type: 1,
                    // },
                    // {
                    //     time: '2019-11-20  09:00',
                    //     language: 1,
                    //     languageNumber:1,
                    //     name: '王某2',
                    //     phone: '139090909099',
                    //     number: 5,
                    //     id: '510101********9106',
                    //     type: 0,
                    // },
                ]
            }
        },
        methods: {
            onLoad() {
                // // 异步更新数据
                // // setTimeout 仅做示例，真实场景中一般为 ajax 请求
                // setTimeout(() => {
                //     // this.randomList();
                //     // // 加载状态结束
                //     // this.loading = false;
                //     // if (this.list.length >= 20) {
                //     //     this.finished = true;
                //     // }
                // }, 1000);
                this.getVolunteerActivityListList();
            },
            getVolunteerActivityListList(){
                http.get(myVolunteerActivityListUrl)
                    .then(res=>{
                        // console.log(res)
                        var {
                            data:{
                                data: array = [],
                                success = false
                            }
                        } = res;
                        if(success){
                            array.map(item=>{
                                this.list.push({
                                    // time: item.create_time,
                                    time: item.order_date + ' ' + item.order_time,
                                    language: item.language,
                                    languageNumber: item.guide_number,
                                    name: item.user_name,
                                    phone: item.phone,
                                    number: item.person_number,
                                    id: item.idcard,
                                    type: item.status,// 状态(1：预定成功；2：已取消)	
                                    isCan: item.allow_cancel || false,
                                    rawData: item,
                                })
                            })
                            this.finished = true;
                        }
                    })
            },
            cancelOrder(item){
                return ()=>{
                    var {
                        rawData: {
                            id: agOrderId
                        },
                        time
                    } = item;
                    this.$dialog.confirm({
                        title: '提示',
                        message: `确认取消${time}时的预约吗?`
                    }).then(() => {
                        if(agOrderId){
                            this.cancelVolunteerActivity(agOrderId)
                        }
                    }).catch(() => {
                    // on cancel
                    });
                }
            },
            cancelVolunteerActivity(agOrderId){
                http.post(cancelVolunteerActivityUrl, {agOrderId})
                    .then(res=>{
                        setTimeout(() => {
                            this.list = [];
                            this.$toast.success('取消预约成功');
                            this.getVolunteerActivityListList();
                        }, 300);
                    })
            },
            // agOrderId
            randomList(){
                var list = [
                        {
                            time: '2019-11-20  09:00',
                            language: 1,
                            languageNumber:1,
                            name: '王某',
                            phone: '139090909099',
                            number: 5,
                            id: '510101********9106',
                            type: 1,
                        },
                        {
                            time: '2019-11-20  09:00',
                            language: 1,
                            languageNumber:1,
                            name: '王某2',
                            phone: '139090909099',
                            number: 5,
                            id: '510101********9106',
                            type: 0,
                        },
                    ]
                for (let index = 0; index < (parseInt(Math.random()*0) + 1); index++) {
                    var tempIndex = parseInt(Math.random()*2);
                    this.list.push(list[tempIndex]);
                }
            },
        },
        components: {
            [List.name]: List,
        }
    }
</script>

<style lang="less" scoped>
    .f-s-b{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .f-c{
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .container{

        .header{
            padding: 0 8px;
            height: 50px;
            box-sizing: border-box;
            justify-content: flex-start;
            .txt{
                margin-left: 10px;
                color: #606060;
                font-size: 14px;
            }
        }

        .render-box{
            padding: 0 8px 8px;
            ._item{
                margin-bottom: 8px;
                font-size: 12px;
                background:rgba(255,255,255,1);
                border-radius:5px;
                padding: 0 8px;
                &:last-of-type{
                    margin: 0;
                }
                .item-header{
                    padding: 20px 10px;
                    color: #606060;
                    border-bottom: .5px solid #D8D8D8;
                }
                .item-body{
                    padding: 15px 10px;
                    ._info-row{
                        color: #989898;
                        margin-bottom: 15px;
                        &:last-of-type{
                            margin: 0;
                        }
                        .language{
                            font-size: 14px;
                            color: #464E55;
                        }
                        .size{
                            font-size: 14px;
                            color: #FF9E15;
                        }
                    }
                }
                .item-foot{
                    border: 0;
                    border-top: .5px solid #D8D8D8;
                    padding: 12px 0;
                    font-size: 13px;
                    color: #B3B3B3;
                    .suc-btn{
                        color: #27AF2D;
                    }
                    .cancel-btn{
                        width:87px;
                        height:29px;
                        background:rgba(237,237,237,1);
                        border-radius:7px;
                    }
                    .txt{
                        width: auto;
                        // height: auto;
                        background: transparent;
                    }
                }
            }
        }

    }

</style>